<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Maintenance Plan and Call
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="shift"
              :label="this.localForm.shift"
              :items="workShiftOptions"
              color="wplblue0"
              prepend-icon="brightness_medium"
              hint="work shift"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="risk"
              :label="this.localForm.risk"
              :items="riskOptions"
              color="wplblue0"
              prepend-icon="priority_high"
              hint="plan risk"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="status"
              :label="this.localForm.status"
              :items="maintPlanStatusForMaintCallOptions"
              color="wplblue0"
              prepend-icon="filter_list"
              hint="call status"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="prep"
              :label="this.localForm.prep"
              :items="maintPlanPrepFactorOptions"
              color="wplblue0"
              prepend-icon="date_range"
              hint="prep. factor"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.batch"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="link"
            hint="batch"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.key"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="vpn_key"
            hint="execution"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Maintenance Call Scope
          </div>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.call"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="work call instructions"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
        <div>
          <v-layout class="text-xs-left ml-2 mr-2 mt-2">
            <div :class="ui.textSubheading">
              Planning {{getDetail.strategy.char.freq}}{{getDetail.strategy.char.unit}}
              {{getDetail.strategy.basic.title}}
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <!-- <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.dplan',
                label: dateTypeA(this.getDetailStats.dplan),
                hint: 'est. next call plan',
                icon: 'event'
                }"
              />
            </v-flex> -->
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.ddue',
                label: dateTypeA(this.getDetailStats.ddue),
                hint: 'next call due',
                icon: 'event_available'
                }"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :label="dateTypeA(this.getDetailStats.dcall)"
              prepend-icon="restore"
              hint="last call due"
              persistent-hint
              readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :label="calcPlanExceed(this.getDetail.strategy.char.freq, this.getDetail.strategy.char.unit, this.getDetailStats.dcall)"
              prepend-icon="date_range"
              hint="due - last"
              suffix="%"
              persistent-hint
              readonly
              ></v-text-field>
            </v-flex>
            <!-- <v-flex xs12 md8 lg6>
              <v-text-field
              :label="calcPlanExpect(this.getDetail.strategy.char.freq, this.getDetail.strategy.char.unit, this.getDetailStats.dcall, this.getDetailStats.ddue)"
              prepend-icon="date_range"
              hint="plan exceedence (plan)"
              suffix="%"
              persistent-hint
              readonly
              ></v-text-field>
            </v-flex> -->
          </v-layout>
        </div>
        <v-layout row class="mr-1 mt-4">
          <v-spacer/>
          <MaintCallNew :data="{btnTitle: 'New Call', btnSize: 'flat'}"/>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import workOptions from "@/data/options/mixins/workOptions.js";
import riskOptions from "@/data/options/mixins/riskOptions.js";
import statusOptions from "@/data/options/mixins/statusOptions.js";
import maintOptions from "@/data/options/mixins/maintOptions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import callFunctions from "@/data/functions/mixins/callFunctions.js";
import DatePicker from "@/data/functions/components/DatePicker";
import MaintCallNew from "@/maintenance/call/components/MaintCallNew";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        planTag: "",
        bname: "",
        risk: "",
        status: "",
        call: "",
        shift: "",
        prep: "",
        batch: "",
        key: ""
      },
      orgForm: {
        planTag: "",
        bname: "",
        risk: "",
        status: "",
        call: "",
        shift: "",
        prep: "",
        batch: "",
        key: ""
      },
      risk: "",
      status: "",
      shift: "",
      prep: ""
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.status = this.getDetail.char.status;
    this.localForm.planTag = this.getDetail.char.planTag;
    this.localForm.bname = this.getDetail.char.bname;
    this.localForm.call = this.getDetail.char.call;
    this.localForm.risk = this.getDetail.char.risk;
    this.localForm.shift = this.getDetail.char.shift;
    this.localForm.prep = this.getDetail.char.prep;
    this.localForm.batch = this.getDetail.char.batch;
    this.localForm.key = this.getDetail.char.key;

    this.orgForm.status = this.getDetail.char.status;
    this.orgForm.planTag = this.getDetail.char.planTag;
    this.orgForm.bname = this.getDetail.char.bname;
    this.orgForm.call = this.getDetail.char.call;
    this.orgForm.risk = this.getDetail.char.risk;
    this.orgForm.shift = this.getDetail.char.shift;
    this.orgForm.prep = this.getDetail.char.prep;
    this.orgForm.batch = this.getDetail.char.batch;
    this.orgForm.key = this.getDetail.char.key;

    // initial calcaulcated dates based on last date
    // let stats = this.getDetailStats;
    // eslint-disable-next-line
    // stats.ddue = this.calcDateDueNext(this.getDetail.strategy.char.freq, this.getDetail.strategy.char.unit, this.getDetailStats.dlast, 1.0);
    // eslint-disable-next-line
    // stats.dplan = this.calcDateDueNext(this.getDetail.strategy.char.freq, this.getDetail.strategy.char.unit, this.getDetailStats.dlast, this.getDetailChar.prep);
    // eslint-disable-next-line
    // stats.dplan = this.calcMaintCallDate(this.getDetailStats.dlast, 4, "w", 0.5);
    // eslint-disable-next-line
    // stats.dplan = moment.format();
    // eslint-disable-next-line
    // this.$store.dispatch("changeDetailStats", stats);
    // stats.dplan = this.calcMaintCallDatePlan(this.getDetailStats.dlast, );
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    riskOptions,
    workOptions,
    statusOptions,
    dateFunctions,
    callFunctions,
    maintOptions
  ],
  watch: {
    risk() {
      this.localForm.risk = this.risk;
      this.updateFormChar();
    },
    status() {
      this.localForm.status = this.status;
      this.updateFormChar();
    },
    shift() {
      this.localForm.shift = this.shift;
      this.updateFormChar();
    },
    prep() {
      this.localForm.prep = this.prep;
      this.updateFormChar();
      // change plan date
      let stats = this.getDetailStats;
      // eslint-disable-next-line
      stats.dplan = this.calcDateDueNext(this.getDetail.strategy.char.freq, this.getDetail.strategy.char.unit, this.getDetailStats.dlast, this.getDetailChar.prep);
      // eslint-disable-next-line
      this.$store.dispatch("changeDetailStats", stats);
    }
  },
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailChar",
      "getDetailStats",
      "getCurrentPage",
      "getDetailLink"
    ])
  },
  components: {
    DatePicker,
    MaintCallNew
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line

      if (
        this.localForm.planTag !== this.orgForm.planTag &&
        this.localForm.planTag !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.planTag = this.localForm.planTag;
        // basic
        char.planTag = this.localForm.planTag;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.bname !== this.orgForm.bname &&
        this.localForm.bname !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.bname = this.localForm.bname;
        // basic
        char.bname = this.localForm.bname;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.risk !== this.orgForm.risk &&
        this.localForm.risk !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.risk = this.localForm.risk;
        // basic
        char.risk = this.localForm.risk;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.status !== this.orgForm.status &&
        this.localForm.status !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.status = this.localForm.status;
        // basic
        char.status = this.localForm.status;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.call !== this.orgForm.call &&
        this.localForm.call !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.call = this.localForm.call;
        // basic
        char.call = this.localForm.call;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.shift !== this.orgForm.shift &&
        this.localForm.shift !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.shift = this.localForm.shift;
        // basic
        char.shift = this.localForm.shift;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.prep !== this.orgForm.prep &&
        this.localForm.prep !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.prep = this.localForm.prep;
        // basic
        char.prep = this.localForm.prep;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.batch !== this.orgForm.batch &&
        this.localForm.batch !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.batch = this.localForm.batch;
        // basic
        char.batch = this.localForm.batch;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.key !== this.orgForm.key &&
        this.localForm.key !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.key = this.localForm.key;
        // basic
        char.key = this.localForm.key;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
